import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useTranslation } from 'react-i18next';

const CATEGORY_COLORS = ['#3b82f6', '#a78bfa', '#f59e0b', '#10b981', '#f43f5e', '#06b6d4'];

const SalesCategoryChart = ({ data }) => {
    const { t } = useTranslation();
    if (!data?.categories?.length) return null;

    const strings = t('salesAnalytics.charts.category', { returnObjects: true });
    const categories = data.categories;
    const totalQty = categories.reduce((s, c) => s + parseFloat(c.total_quantity || 0), 0);

    const pieData = categories.map((item, i) => ({
        id: i,
        value: parseFloat(item.total_quantity) || 0,
        label: item.category_name,
        color: CATEGORY_COLORS[i % CATEGORY_COLORS.length],
    }));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.heading}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 16px 4px' }}>
                <PieChart
                    series={[{
                        data: pieData,
                        innerRadius: '52%',
                        paddingAngle: 2,
                        cornerRadius: 4,
                        arcLabel: null,
                        highlightScope: { faded: 'global', highlighted: 'item' },
                    }]}
                    slotProps={{ legend: { hidden: true } }}
                    margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                    width={200}
                    height={200}
                />
            </div>
            <div style={{ padding: '4px 16px 16px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {categories.map((cat, i) => {
                    const qty = parseFloat(cat.total_quantity) || 0;
                    const pct = totalQty > 0 ? ((qty / totalQty) * 100).toFixed(1) : 0;
                    const color = CATEGORY_COLORS[i % CATEGORY_COLORS.length];
                    return (
                        <div key={cat.category_id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', borderRadius: 8, backgroundColor: '#f9fafb' }}>
                            <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
                            <span style={{ fontSize: 13, color: '#374151', flex: 1, fontWeight: 500 }}>{cat.category_name}</span>
                            <span style={{ fontSize: 12, fontWeight: 700, color: '#111827' }}>{Number(qty.toFixed(0)).toLocaleString('en-IN')}</span>
                            <span style={{ fontSize: 11, fontWeight: 600, color, backgroundColor: `${color}20`, borderRadius: 12, padding: '2px 8px', minWidth: 40, textAlign: 'center' }}>
                                {pct}%
                            </span>
                            <span style={{ fontSize: 11, color: '#9ca3af', minWidth: 36, textAlign: 'right' }}>
                                {cat.order_count} {strings.orderCountSuffix}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 14px', borderBottom: '1px solid #f9fafb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default SalesCategoryChart;
